var path = 'app/scripts/modules/core/src/task/platformHealthOverrideMessage.html';
var html = "<p>\n  Task not completing?\n</p>\n<p>\n  By default, Spinnaker does not consider cloud provider health (i.e. whether your instances have launched and are running)\n  as a reliable indicator of instance health.\n</p>\n<p>\n  If your instances do not provide a health indicator known to Spinnaker\n  (e.g. a discovery service or load balancers), you should configure your application to\n  consider only cloud provider health when executing tasks. This option is available under Application Attributes\n  in the <b>Config tab</b>.\n</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/task/platformHealthOverrideMessage.html
// module id = 1128
// module chunks = 0